import React, { useState } from 'react';
import { StepContainer, StepNavigation } from '../components';
import { StepProps, useFormContext } from '../context';
import { useFormValidation } from '../hooks';
import { EnderecoCompleto } from '../sections';

export const Step12_Endereco: React.FC<StepProps> = ({ onNext, onPrevious, isLoading }) => {
  const { data, updateField } = useFormContext();
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleNext = () => {
    const newErrors: Record<string, string> = {};

    if (!data.cep) newErrors.cep = 'CEP é obrigatório';
    if (!data.address) newErrors.address = 'Endereço é obrigatório';
    if (!data.addressNumber) newErrors.addressNumber = 'Número é obrigatório';
    if (!data.neighborhood) newErrors.neighborhood = 'Bairro é obrigatório';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onNext({ cep: data.cep, address: data.address, addressNumber: data.addressNumber, complement: data.complement, neighborhood: data.neighborhood });
  };

  const handleFieldChange = (newData: Partial<typeof data>) => {
    Object.keys(newData).forEach(key => {
      updateField(key as keyof typeof data, newData[key as keyof typeof data]);
      if (errors[key]) {
        setErrors(prev => {
          const newErrors = { ...prev };
          delete newErrors[key];
          return newErrors;
        });
      }
    });
  };

  return (
    <StepContainer title="">
      <div className="mb-6">
        <p className="font-semibold mb-2">Qual seu endereço residencial?</p>
        <p className="text-muted-foreground text-sm mb-4">
          Precisamos validar sua residência para processar o consignado. Digite seu CEP e os dados serão preenchidos automaticamente.
        </p>
      </div>
      <EnderecoCompleto
        data={{
          cep: data.cep || '',
          address: data.address || '',
          addressNumber: data.addressNumber || '',
          complement: data.complement || '',
          neighborhood: data.neighborhood || '',
        }}
        onChange={handleFieldChange}
      />
      <StepNavigation onPrevious={onPrevious} onNext={handleNext} isLoading={isLoading} />
    </StepContainer>
  );
};

export default Step12_Endereco;
